import React from 'react';
import './ClientCarousel.css';

const toClientName = (fileName) => {
  const base = fileName.replace(/\.[^/.]+$/, '');
  return base
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase()); 
};

const imagesContext = require.context(
  '../pages/Home/assets/client-imges',
  false,
  /\.(png|jpe?g|svg)$/i
);

const clients = imagesContext
  .keys()
  .sort((a, b) => a.localeCompare(b))
  .map((key) => {
    const fileName = key.replace('./', '');
    return {
      src: imagesContext(key),
      name: toClientName(fileName),
    };
  });


const ClientCarousel = () => (
  <section className="clients-section">
    <div
      className="clients-carousel"
      style={{ '--client-count': clients.length }}
    >
      <div className="carousel-track">
        {clients.map((client, i) => (
          <div className="carousel-item" key={`orig-${i}`}>
            <img src={client.src} alt={client.name} />
          </div>
        ))}
        {clients.map((client, i) => (
          <div className="carousel-item" key={`dup-${i}`}>
            <img src={client.src} alt={client.name} />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ClientCarousel;